import { useState } from 'react';
import { KTSVG } from 'src/_metronic/helpers/components/KTSVG';
import { getBannerSize } from '../../utils/banner-size';
import ImageUploadModal from '../Modal';

type VendorBannersType = {
  mobileDevice: boolean;
  bannerData: any;
  templateId: number;
  heightMobile: number;
  heightWeb: number;
};

export default function VendorBanners(props: VendorBannersType) {
  const { mobileDevice, bannerData, templateId, heightMobile, heightWeb } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [bannerResponse, setBannerResponse] = useState<any>([]);
  const handleBannerResponse = (newItem: any) => {
    setBannerResponse((prev: any) => {
      const index = prev.findIndex((item: any) => item?.placeholder === newItem?.placeholder && item?.sort === newItem?.sort);

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = newItem;
        return updated;
      }

      return [...prev, newItem];
    });
  };

  if (!bannerData?.status) return null;
  const activeData = bannerResponse?.[0]?.filter((item: any) => item?.placeholder === bannerData?.position?.placeholder) || [];
  // Ölçü ruleSet'ten (max_width / ratio); ruleSet eksikse şablondaki sabit yüksekliklere düşülür.
  const bannerSize = getBannerSize(bannerData?.ruleSet);
  return (
    <>
      <ImageUploadModal
        show={modalOpen}
        handleClose={() => setModalOpen(false)}
        maxSize={bannerData?.ruleSet?.max_size}
        allowTypes={bannerData?.ruleSet?.type}
        sortIndex={index}
        itemTypeId={bannerData?.id}
        templateId={templateId}
        setBannerResponse={handleBannerResponse}
      />
      <div className={`row px-6 ${mobileDevice ? 'g-4' : 'g-10'}`}>
        {Array.from({ length: bannerData?.position?.maxLimit }).map((_, index) => (
          <div
            key={index}
            onClick={() => (setModalOpen(true), setIndex(index + 1))}
            className={`${mobileDevice ? 'col-12' : bannerData?.position?.maxLimit === 1 ? 'col-12' : bannerData?.position?.maxLimit === 2 ? 'col-6' : 'col-4'}`}
          >
            <div
              className="d-flex align-items-center justify-content-center border border-secondary bg-light cursor-pointer"
              style={bannerSize ? { aspectRatio: bannerSize.aspectRatio } : { height: mobileDevice ? `${heightMobile}px` : `${heightWeb}px` }}
            >
              {activeData.length > 0 && activeData.find((f: any) => f.sort === index + 1)?.sort === index + 1 ? (
                <img src={activeData.length > 0 && activeData.find((f: any) => f.sort === index + 1)?.image} alt="banner" className="w-100 h-100 object-fit-cover" />
              ) : bannerData?.banners?.length > 0 && bannerData?.banners?.find((f: any) => f.sort === index + 1)?.image ? (
                <img src={bannerData?.banners?.find((f: any) => f.sort === index + 1)?.image} alt="banner" className="w-100 h-100 object-fit-cover" />
              ) : (
                <div className="d-flex flex-column gap-2 align-items-center">
                  <KTSVG path="/media/icons/duotone/Files/Upload.svg" className="svg-icon-1 svg-icon-primary" />
                  <span className="text-muted fs-4 fw-bold">
                    {bannerSize
                      ? `${bannerSize.width} X ${bannerSize.height}`
                      : `${mobileDevice ? '375' : bannerData?.ruleSet?.max_width || 662} X ${mobileDevice ? heightMobile : heightWeb}`}
                  </span>
                  <span className="text-primary">Yükleme yapmak için dokunun.</span>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
